import { render, staticRenderFns } from "./DispatchNoList.vue?vue&type=template&id=310be0d2&scoped=true&"
import script from "./DispatchNoList.vue?vue&type=script&lang=js&"
export * from "./DispatchNoList.vue?vue&type=script&lang=js&"
import style0 from "./DispatchNoList.vue?vue&type=style&index=0&id=310be0d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310be0d2",
  null
  
)

export default component.exports